import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider
} from '@material-ui/core';
import moment from 'moment';
import Controls from '../controls/Controls';

import { useConstantsContext } from '../../context/constants_context';
import { useClientContext } from '../../context/client_context';
import {
  baseUrl,
  gender,
  employers,
  tierSchemes,
  employerCodes,
  memberStatuses
} from '../../utils/constants';

export default function BenefitsPersonal() {
  const { towns, suburbs, banks } = useConstantsContext();
  const { currentClient } = useClientContext();
  const BenefitsPersonalSchema = Yup.object().shape({
    dateOfBirth: Yup.date()
  });

  const initialValue = {
    firstName: currentClient.firstName,
    surname: currentClient.surname,
    idNumber: currentClient.idNumber,
    dateOfBirth: moment(currentClient.dateOfBirth).format('yyyy-MM-DD'),
    membershipStartDate: moment(currentClient.membershipStartDate).format('yyyy-MM-DD'),
    termdate: moment(currentClient.termdate).format('yyyy-MM-DD'),
    gender: currentClient.gender,
    memberShipNo: currentClient.memberShipNo,
    memberStatus: currentClient.memberStatus,
    addressLine3: currentClient.addressLine3,
    provinceLookupKey: currentClient.provinceLookupKey,
    cellNumber: currentClient.cellNumber,
    emailAddress: currentClient.emailAddress,
    maritalStatus: currentClient.maritalStatus,
    employerRefId: currentClient.employerRefId,
    paypointRefId: currentClient.paypointRefId,
    postalCode: currentClient.postalCode,
    group_id: currentClient.group_id,
    sex_ID: currentClient.sex_ID,
    title_id: currentClient.title_id,
    age: currentClient.age,
    principalSchemeID: currentClient.principalSchemeID,
    physical_Town_ID: currentClient.physical_Town_ID,
    physical_Suburb_ID: currentClient.physical_Suburb_ID,
    bank_ID: currentClient.bank_ID,
    acc_No: currentClient.acc_No,
    acc_Name: currentClient.acc_Name,
    home_Phone: currentClient.home_Phone,
    postal_Phone: currentClient.postal_Phone,
    physical_Add1: currentClient.physical_Add1,
    accName: currentClient.accName,
    station: currentClient.station,
    retirementDate: moment(currentClient.retirementDate).format('yyyy-MM-DD'),
    clothingSize: currentClient.clothingSize
  };

  useEffect(() => {
    // setFormData(initialValue);
  }, [currentClient]);

  const formik = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,
    validationSchema: BenefitsPersonalSchema,
    onSubmit: (values) => {
      console.log('custingo before that exe 2', values);
    }
  });
  console.log('Dependants curr before that exe 3', currentClient);
  const date1 = moment(currentClient.dateOfBirth);
  const date2 = moment();
  const diff = date2.diff(date1, 'years');
  currentClient.age = diff;

  return (
    <Card>
      <CardContent>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate>
            <Typography variant="subtitle1" gutterBottom>
              Personal Info...
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={2}>
                <Controls.Input name="memberShipNo" label="Member #" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="firstName" label="First Name" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="surname" label="Last Name" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="idNumber" label="Id Number" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.SelectJson name="sex_ID" label="Gender" options={gender} />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.DateTime name="dateOfBirth" label="Date Of Birth" />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Controls.Input name="age" label="Age" />
              </Grid>

              <Grid item xs={12} sm={3}>
                <Controls.DateTime name="retirementDate" label="Retirement Date" />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.DateTime name="membershipStartDate" label="Membership Start Date" />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.SelectJson
                  name="memberStatus"
                  label="Member Status"
                  options={memberStatuses}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.DateTime name="termdate" label="Terminated Date" />
              </Grid>

              <Grid item xs={12} sm={2}>
                <Controls.Input name="home_Phone" label="Contact #" />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Controls.Input name="station" label="Address" />
              </Grid>

              <Grid item xs={12} sm={2}>
                <Controls.SelectJson
                  name="group_id"
                  label="Group"
                  options={employerCodes}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <FormControl fullWidth>
                  <InputLabel id="group_idlabel">Group</InputLabel>
                  <Select
                    id="group_id"
                    value={formik.values.group_id}
                    name="group_id"
                    fullWidth
                    size="small"
                    variant="outlined"
                  >
                    {employers.map((item) => (
                      <MenuItem key={item.refId} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="clothingSize" label="Clothing Size" />
              </Grid>
              <Divider style={{ background: '#832025', height: 1, margin: 2, paddingTop: 4 }} />
            </Grid>
          </Form>
        </FormikProvider>
      </CardContent>
    </Card>
  );
}
